<div class="background">
  <iframe
    class="embedded-website"
    [src]="url"
    style="border: 0"
  ></iframe>
</div>
